import { DefaultResponse } from './index';

interface Child {
  amount: string;
  id: string;
  ref1: string;
  ref2: string | null;
  updatedAt: string;
  updatedBy: string;
  type: string | null;
}

interface SourceOfFund {
  name: string;
  code: string;
}

export interface TransactionBody {
  id: string;
  transactionID: string;
  updatedAt: string;
  updatedBy: string;
  amount: string;
  currency: string;
  status: string;
  ref1: string;
  ref2: string | null;
  description: string | null;
  payerName: string | null;
  fundsUID: string | null;
  sourceOfFund: SourceOfFund | null;
  mid: string;
  merchantName: string;
  merchantBusinessType: string;
  tid: string;
  rFeeType: string | null;
  rFeeAmount: string | null;
  rAcquirerMDRType: string | null;
  rAcquirerMDRAmount: string | null;
  rIssuerMDRType: string | null;
  rIssuerMDRAmount: string | null;
  transferAmount: string | null;
  rVATAmount: string;
  rWHTAmount: string;
  calFeeAmount: string | null;
  calVATAmount: string | null;
  calWHTAmount: string | null;
  calAcquirerMDRAmount: string | null;
  calIssuerMDRAmount: string | null;
  createdAt: string | null;
  confirmingAt: string | null;
  pendingAt: string | null;
  dropOffAt: string | null;
  authorizedAt: string | null;
  authorizedVoidedAt: string | null;
  rejectedAt: string | null;
  capturedAt: string | null;
  unmatchedAt: string | null;
  clearedAt: string | null;
  clearedPendingRefundAt: string | null;
  clearedRefundedAt: string | null;
  cancelledAt: string | null;
  refundRequestPendingAt: string | null;
  child: Child | null;
}
export const TransactionLogType = [
  'pendingAt',
  'authorizedAt',
  'rejectedAt',
  'capturedAt',
  'clearedAt',
  'unmatchedAt',
  'dropOffAt',
  'authorizedVoidedAt',
  'cancelledAt',
  'clearedPendingRefundAt',
  'clearedRefundedAt',
  'createdAt',
  'confirmingAt',
  'refundRequestPendingAt',
] as const;

// eslint-disable-next-line no-redeclare
export type TransactionLogType = typeof TransactionLogType[number];

export const RequestRefundTransactionLog = [
  'requestedAt',
  'approvedAt',
  'rejectedAt',
  'cancelledAt',
] as const;
// eslint-disable-next-line no-redeclare
export type RequestRefundTransactionLog =
  typeof RequestRefundTransactionLog[number];

export type LogItem = {
  label: string;
  date: string | undefined;
  typeReason?: string;
  email?: string;
  description?: string | null;
};

export type TransactionResponse = DefaultResponse<TransactionBody>;

export type RequestRefundTxArgs = {
  reason: string;
  reasonType: string;
  txId: string;
};

export type RequestRefundTxResponse = {
  id: string;
  request_description: string;
  request_type: string;
  status: string;
};

export type RequestRefundType = {
  id: string;
  status: string;
  requestedAt: string;
  requestDescription: string;
  requestTypeReason: string;
  requestedEmail: string;
  approvedAt: string;
  rejectedAt: string;
  approveDescription?: string | null;
  approvedEmail?: string;
  rejectDescription?: string;
  rejectTypeReason?: string;
  rejectedEmail?: string;
  cancelledAt: string;
  cancelledEmail?: string;
};

export type CancelRefundTxArgs = {
  requestTxApprovalId: string;
  txID: string;
};
export type RefundRequestTypes = {
  id: string;
  name: string;
  description: string;
  status: string;
};

export type RefundRequestTypesResponse = DefaultResponse<RefundRequestTypes[]>;
